//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { massiveSelectRequestsMixin } from '@/apps/data-platform/mixins/massive_select_requests';
import AssignmentsService from '@/apps/data-platform/services/tables_views/assignments_service';
import BiDatasetService from '@/apps/data-platform/services/visualization/bi_dataset_service';
import { textsDefaul, envConfig, ACCESS_TYPE_FLOW, TYPE_CHANGE_METADA } from '@/js/constants';
import utils from '@/js/utils';
import FormChangeMetaDataDataset from '@/modules/tasks/powerbi/components/FormChangeMetaDataDataset';
import FormAccessRequestDataset from '@/modules/tasks/powerbi/components/FormAccessRequestDataset';
import DialogsComponent from '@/components/DialogsComponent.vue';
import StateComponent from '@/components/StateComponent.vue';
import FormMetadata from '@/components/FormMetadata.vue';
export default {
  name: 'ListDatasetAccessRequested',
  mixins: [massiveSelectRequestsMixin],
  components: {
    FormChangeMetaDataDataset: FormChangeMetaDataDataset,
    FormAccessRequestDataset: FormAccessRequestDataset,
    DialogsComponent: DialogsComponent,
    StateComponent: StateComponent,
    FormMetadata: FormMetadata
  },
  props: {
    typeFlow: {
      type: String,
      required: true,
      default: ''
    }
  },
  data: function data() {
    return {
      MODAL_DATASET_CHANGE_METADATA: 'MODAL_DATASET_CHANGE_METADATA',
      MODAL_DATASET_ACCESS_REQUEST: 'MODAL_DATASET_ACCESS_REQUEST',
      messageEmptyListDs: textsDefaul.LOADING,
      lst_dataset: [],
      titleModal: 'View Metadata Change (Validation)',
      item: Object,
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      currentModal: '',
      PAGE_TAGS_SIZE: envConfig.pagintaionTagsSize,
      PAGE_SIZE: envConfig.pagintaionSize,
      limit: envConfig.pagintaionSize,
      show_table: false,
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      filter: '',
      key_meta: 1,
      key_access: 1
    };
  },
  computed: {
    composeName: function composeName() {
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var text = '';
        if (item) {
          text = "".concat(item.path_name, "/").concat(item.object_name).replace(/\//g, '&nbsp;/&nbsp;');
        }
        return text;
      };
    },
    fieldsDs: function fieldsDs() {
      return [{
        text: this.traductor('my_pendings.tablas.dataset'),
        value: 'objectReference.object_name',
        sortable: true,
        class: 'text-left'
      }, {
        text: this.traductor('my_pendings.tablas.user'),
        value: 'applicant',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_pendings.tablas.request_date'),
        value: 'created_datetime',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_pendings.tablas.actions'),
        value: 'actions',
        align: 'center'
      }];
    }
  },
  created: function created() {
    this.reloadDataset();
  },
  methods: {
    onSearch: function onSearch(text) {
      this.filter = text;
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onReferenceClose: function onReferenceClose() {
      this.show_table = false;
    },
    onShowTable: function onShowTable(table) {
      var _this = this;
      var rowData = utils.cloneJSON(table);
      // validate user info
      var userLogin = window.userInfo && window.userInfo.userLogin;
      if (!userLogin) return false;
      var params = {
        relativeResourceName: rowData.relativeResourceName,
        pageSize: this.PAGE_TAGS_SIZE,
        email: userLogin.email,
        index_node: rowData.index_node,
        domain_table: rowData.domain_table
      };
      AssignmentsService.getListTagEntry(params).then(function (response) {
        if (response.code === 200) {
          _this.objToRequest = response.data;
          _this.objToRequest.item = rowData;
          _this.objToRequest.tipo = 'edicion';
          _this.show_table = true;
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    reloadDataset: function reloadDataset() {
      var _this2 = this;
      var email = window.userInfo.email;
      var typeFlow = this.typeFlow;
      var domain = window.userInfo.domain;
      this.lst_dataset = [];
      BiDatasetService.datasetPendingApproval({
        typeFlow: typeFlow,
        email: email,
        domain: domain
      }).then(function (response) {
        if (response && response.code === 200) {
          if (response.data && response.data.items && response.data.items.length) {
            _this2.lst_dataset = response.data.items;
          } else {
            _this2.lst_dataset = [];
            _this2.messageEmptyListDs = textsDefaul.NOT_FOUND;
          }
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    onOwnerDs: function onOwnerDs(item) {
      var modalName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      this.item = item;
      this.key_meta += 1;
      this.key_access += 1;
      if (item.type === ACCESS_TYPE_FLOW.ACCESS) {
        var modal = modalName || this.MODAL_DATASET_ACCESS_REQUEST;
        this.currentModal = modal;
      } else if (item.type === ACCESS_TYPE_FLOW.CHANGE_METADATA) {
        this.currentModal = this.MODAL_DATASET_CHANGE_METADATA;
      }
      //this.$bvModal.show(this.currentModal)
      this.$refs[this.currentModal].onOpen();
    },
    onCloseModalDs: function onCloseModalDs(reload) {
      //this.$bvModal.hide(this.currentModal)
      this.$refs[this.currentModal].onClose();
      if (reload) {
        this.reloadDataset();
      }
    }
  }
};